import {Component} from 'react';

class Auxy extends Component {
 render (){
   return this.props.children
 }
}
export default Auxy;
